'use strict';

exports.__esModule = true;
exports['default'] = getScrollbarWidth;

function getScrollbarWidth(className) {
    var div = document.createElement('div');
    div.className = className;
    document.body.appendChild(div);
    var scrollbarWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    return scrollbarWidth;
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-scrollbars/lib/utils/getScrollbarWidth.js
// module id = 217
// module chunks = 0 1 9